import { NextSeo } from 'next-seo';
import { Fragment } from 'react';
import { useBuildingsProvider } from '../../../context/buildings';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import Splitter from '../../../components/Splitter';
import Button from '../../../components/Button';
import BuildingsCatalog from '../../../components/buildings/BuildingsCatalog';
import BuildingsFilter from '../../../components/buildings/BuildingsFilter';
import BuildingsFilterMobile from '../../../components/buildings/BuildingsFilterMobile';
import css from '../../../styles/modules/buildings/Buildings.module.scss';

import { useLocationProvider } from '../../../context/location';

const isAnyFilters = (s) => {
  const arrFilters = [
    'rooms',
    'studio',
    'deadlineQuartal',
    'deadlineYear',
    'priceFrom',
    'priceTo',
    'squareFrom',
    'squareTo',
    'renovation',
    'squareLivingFrom',
    'squareLivingTo',
    'squareKitchenFrom',
    'squareKitchenTo',
    'balcony',
    'ceiling',
    'floorFrom',
    'floorTo',
    'floorsFrom',
    'floorsTo',
    'bathroom',
    'buildingType'
  ];
  let filtersTotal = 0;

  for (let i = 0; i < arrFilters.length; i++)
    if (
      s[arrFilters[i]] &&
      (s[arrFilters[i]].length || s[arrFilters[i]] > 0)
    )
      filtersTotal++;

  return filtersTotal > 0;
};

const PageBuildings = ({ date }) => {
  /** STATES */
  const [buildingsState, setBuildingsState] = useBuildingsProvider();
  const [locationState] = useLocationProvider();

  /** FUNCTIONS */
  const onSortChange = (e) => {
    const selectedOption = [...e.target.options].filter((x) => x.selected)[0];
    const groupedSelected = {
      sort: selectedOption.value.split('/')[0],
      direction: selectedOption.value.split('/')[1]
    };

    setBuildingsState({ type: 'SET_PAGINATION', payload: { page: 1 } });
    setBuildingsState({
      type: 'SET_SORTING',
      payload: {
        sort: groupedSelected.sort,
        sortDirection: groupedSelected.direction
      }
    });
  };
  const openMobileFilters = () => {
    setBuildingsState({
      type: 'SET_STATE',
      payload: { ...buildingsState.state, isFiltersMobileVisible: true }
    })
  };

  return (
    <Fragment>
      <NextSeo
        title= {`Купить квартиру в новостройке в ${locationState.case}`}
        description= {`Продажа жилья в новостройках в ${locationState.case}. Купить квартиру в новостройке недорого: цены, свежие объявления, срочная продажа.`}
        openGraph={{
          url: `https://${process.env.NEXT_PUBLIC_SITEDOMAIN}`,
          type: 'website',
          title: `Купить квартиру в новостройке в ${locationState.case}`,
          description: `Продажа жилья в новостройках в ${locationState.case}. Купить квартиру в новостройке недорого: цены, свежие объявления, срочная продажа.`,
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: process.env.NEXT_PUBLIC_SITENAME
        }}
      />
      <Header />
      <main className="core">
        <BuildingsFilter date={date} />
        <BuildingsFilterMobile date={date} />
        {!buildingsState.state.isFiltersMobileVisible && (
          <div className={css.filterMobileActions}>
            <Button onClick={openMobileFilters} color="black">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
              </svg>
              <span className={css.filterMobileButtonText}>Фильтры</span>
              {isAnyFilters(buildingsState.filter) && <span className={css.filterMobileButtonMark} />}
            </Button>
            <Button style={{ width: 52, height: 52, marginLeft: 4 }} withShadow color="yellow">
              <select
                value={`${buildingsState.sorting.sort || 'price.value'}/${buildingsState.sorting.sortDirection || 'price.asc'}`}
                style={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, opacity: 0 }}
                onChange={onSortChange}
              >
                <option value="built-year.max">
                  По сроку сдачи
                </option>
                <option value="price.value/asc">
                  Цена по возрастанию
                </option>
                <option value="price.value/desc">
                  Цена по убыванию
                </option>
                <option value="priceM2/asc">
                  Цена по убыванию за м²
                </option>
                <option value="priceM2/desc">
                  Цена по убыванию за м²
                </option>
              </select>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M8 5V19" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path><path d="M16 19V5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path><path d="M12 14L8 19L4 14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path><path d="M12.0039 10L16.0039 5L20.0039 10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
            </Button>
          </div>
        )}
        <BuildingsCatalog />
        {/* <Splitter
          title="Не нашли что искали?"
          subtitle="Оставьте свой номер телефона и мы поможем Вам с подбором новостройки"
        /> */}
      </main>
      <Footer seo={['Новостройки', locationState.seo.footer].join(' ')} />
    </Fragment>
  );
};

export async function getServerSideProps() {
  return {
    props: {
      date: new Date().getTime()
    }
  };
}

export default PageBuildings;
